import React from 'react';

import { SIGNUP_PATHS } from '../../../constants';

import './auth-banner.scss';
import '../authorization.scss';

interface AuthBannerProps {
  locationPath: string;
}

const AuthBanner: React.FC<AuthBannerProps> = ({ locationPath }) => (
  <div className="authorization__right">
    <div className="authorization__qustion">
      <div className="questions">
        <div className="questions__phone">
          <p className="text-5 questions__title">Вопросы?</p>
          <a className="text-5 questions__link" href="mailto:info@cfa.digital">
            info@cfa.digital
          </a>
        </div>
        {/*<div className="questions__action">*/}
        {/*  <ChatBtn sm />*/}
        {/*</div>*/}
      </div>
    </div>
    {locationPath !== SIGNUP_PATHS.AGREEMENT &&
      locationPath !== SIGNUP_PATHS.KEY_GENERATION &&
      locationPath !== SIGNUP_PATHS.KEY_GENERATION_RESULT &&
      locationPath !== '/restore-key' && (
        <p className="title-1 authorization__title">
          Платформа
          <br />
          Цифровых Финансовых
          <br />
          Активов
        </p>
      )}
  </div>
);

export default AuthBanner;
